import React from 'react'
import { searchClients } from '../../services/clients'
import CustomAsyncSelect from './CustomAsyncSelect';

const ClientSelect = ({ name, control, rules }) => {
    // Fetch function specifically for Clients 
    const loadClients = async (inputValue) => {
        if (inputValue.length < 3) {
            return [];
        }
        
        try {
            const response = await searchClients(inputValue);
            // Return array of clients from Laravel API 
            return response.data.map((client) => ({label: client.name, value: client.id}));
        } catch {
            return [];
        }
    }
  return (
    <CustomAsyncSelect
        name={name}
        placeholder='Search for a client....'
        control={control}
        rules={rules}
        loadOptions={loadClients}
    />
  )
}

export default ClientSelect